import React from 'react';
import './InputForms.scss';
import TextInput from './TextInput'
import Checkbox from './Checkbox'
import TextArea from './TextArea'
import { SendEmailError } from './EmailService'

class ErrorForm extends React.Component {
    state = {
        adress: '',
        apartmentNumber: '',
        name: '',
        emailadress: '',
        telephoneNumber: '',
        allowingEntry: false,
        description: '',
        validData: null,
        mailSent: false,
        sendDisabled: false
    }

    validData = () => {
        return this.state.adress.length > 0
            && this.state.apartmentNumber.length > 0
            && this.state.name.length > 0
            && this.state.emailadress.length > 0
            && this.state.description.length > 0
    }

    sendButtonClicked = async () => {
        this.setState({ sendDisabled: true })
        setTimeout(() => this.setState({ sendDisabled: false }), 3000);
        if (this.validData()) {
            await SendEmailError(this.state);
            this.setState({ validData: true, adress: '', apartmentNumber: '', name: '', emailadress: '', telephoneNumber: '', allowingEntry: false, description: '', mailSent: true })
        }
        else {
            this.setState({ validData: false })
        }
    }

    render() {
        return <div className='errorContainer'>
            <div className='textArea'>
                Här kan du enkelt och smidigt göra en felanmälan till oss. Är det något som behöver åtgärdas akut kontaktar du oss via telefon.
            </div>
            <h1>Felanmälan</h1>

            <TextInput onChange={(event: any) => this.setState({ adress: event.target.value })} required={true} label={'Adress'} value={this.state.adress} />

            <TextInput onChange={(event: any) => this.setState({ apartmentNumber: event.target.value })} required={true} label={'Lägenhetsnr'} value={this.state.apartmentNumber} />

            <TextInput onChange={(event: any) => this.setState({ name: event.target.value })} required={true} label={'För- och Efternamn'} value={this.state.name} />

            <TextInput onChange={(event: any) => this.setState({ emailadress: event.target.value })} required={true} label={'Epostadress'} value={this.state.emailadress} />

            <TextInput onChange={(event: any) => this.setState({ telephoneNumber: event.target.value })} required={true} label={'Telefonnummer'} value={this.state.telephoneNumber} />

            <Checkbox onChange={(event: any) => this.setState({ allowingEntry: !this.state.allowingEntry })} required={false} label={'Kryssa i rutan om du ger tillåtelse att vi eller hantverkare går in i lägenheten om ingen är hemma.'} value={this.state.allowingEntry} Checkbox />

            <TextArea onChange={(event: any) => this.setState({ description: event.target.value })} required={true} label={'Felbeskrivning'} value={this.state.description} />

            <button className='sendButton' disabled={(this.state.sendDisabled || !this.validData())} onClick={() => this.sendButtonClicked()}>Skicka</button>

            {this.state.mailSent && <span className={'mailSent'}>Tack för att du kontaktade oss.</span>}
        </div>
    }
}

export default ErrorForm